(() => {
  const product=window.ViuletJourneyProduct, config=window.VIULET_GALLERY_CONFIG;
  if(!product || !config) return;
  // Where this Mirror was designed, kept on its order line (keys starting with _ never show to the customer).
  const designed=()=>({_design_source:'mirror_page',_design_page:window.location.pathname,_design_version:'1'});
  const preview=window.StrawberryPreview===true;
  const sellable=v=>!!v&&(preview||v.available);
  // A Mirror is built to order. The designer says how long that takes, under its buttons.
  config.deliveryNote=preview?'Private preview. Purchasing is not enabled.':product.variants.some(v=>v.available)?'Built to order in three to five weeks.':'';
  const currency=window.ViuletJourneyCurrency || 'USD';
  config.previewPricing=false;
  const sizeIndex=product.options.findIndex(option=>(typeof option==='string'?option:option.name)==='Size');
  config.sizeStartingPrices={};
  for(const variant of product.variants){
    if(!sellable(variant) || sizeIndex<0 || !Number.isFinite(variant.price))continue;
    const size=variant.options[sizeIndex],amount=variant.price/100;
    if(!config.sizeStartingPrices[size] || amount<config.sizeStartingPrices[size].amount){
      config.sizeStartingPrices[size]={amount,currency};
    }
  }
  config.optionPriceDifference=(selection,field,value)=>{
    const options=product.options.map(option=>typeof option==='string'?option:option.name);
    const rows=product.variants.filter(v=>sellable(v)&&v.options[sizeIndex]===String(selection.size));
    const presentationIndex=options.indexOf('Presentation'),finishIndex=options.indexOf('Finish and mat');
    const minimum=variants=>variants.length?Math.min(...variants.map(v=>v.price)):null;
    let baseline,amount;
    if(field==='presentation'){
      baseline=minimum(rows);
      amount=minimum(rows.filter(v=>v.options[presentationIndex]===value));
    }else{
      const framed=rows.filter(v=>v.options[presentationIndex]===selection.presentation);
      if(field==='finish'){
        const suffix=selection.presentation==='Crowned'?' / '+selection.mat:'';
        baseline=minimum(framed.filter(v=>!suffix||v.options[finishIndex].endsWith(suffix)));
        amount=minimum(framed.filter(v=>v.options[finishIndex]===value+suffix));
      }else if(field==='mat'){
        baseline=minimum(framed.filter(v=>v.options[finishIndex].startsWith(selection.finish+' / ')));
        amount=minimum(framed.filter(v=>v.options[finishIndex]===selection.finish+' / '+value));
      }
    }
    return amount==null||baseline==null?null:{amount:(amount-baseline)/100,currency};
  };
  const optionNames=product.options.map(o=>typeof o==='string'?o:o.name);
  const presentationIndex=optionNames.indexOf('Presentation'),finishIndex=optionNames.indexOf('Finish and mat');
  const optionMap=s=>({'Size':String(s.printInches??s.size),'Presentation':s.presentation,'Finish and mat':s.presentation==='Untethered'?'None':s.presentation==='Crowned'?s.finish+' / '+s.mat:s.finish});
  const match=s=>product.variants.find(v=>optionNames.every((name,i)=>v.options[i]===optionMap(s)[name]));
  config.artwork.dimensions=[...new Set(product.variants.map(v=>Number(v.options[sizeIndex])))].filter(Number.isFinite).sort((a,b)=>a-b);
  config.normalizeSelection=s=>{
    if(sellable(match(s)))return s;
    const v=product.variants.find(v=>sellable(v)&&v.options[sizeIndex]===String(s.printInches ?? s.size)&&v.options[presentationIndex]===s.presentation);
    if(!v)return s;
    const [finish,mat]=v.options[finishIndex].split(' / ');
    return {...s,finish:finish==='None'?s.finish:finish,mat:mat||s.mat};
  };
  config.isChoiceAvailable=(s,field,value)=>{
    if(field==='presentation')return product.variants.some(v=>sellable(v)&&v.options[sizeIndex]===String(s.printInches ?? s.size)&&v.options[presentationIndex]===value);
    return sellable(match({...s,[field]:value}));
  };
  config.resolvePrice=async selection=>{
    const finish=selection.presentation==='Untethered'?'None':selection.presentation==='Crowned'?selection.finish+' / '+selection.mat:selection.finish;
    const chosen={'Size':String(selection.printInches ?? selection.size),'Presentation':selection.presentation,'Finish and mat':finish};
    const variant=product.variants.find(v=>product.options.every((name,i)=>v.options[i]===chosen[typeof name==='string'?name:name.name]));
    if(!variant) throw new Error('This presentation is not configured for this product.');
    if(!sellable(variant)) throw new Error('This presentation is currently unavailable.');
    return {amount:variant.price/100,currency,variantId:variant.id,test:false};
  };
  let cartRequest;
  config.onClaim=selection=>{
    if(preview)return Promise.reject(new Error('This is a private preview. Purchasing is not enabled.'));
    if(cartRequest) return cartRequest;
    cartRequest=(async()=>{
      const quote=await config.resolvePrice(selection);
      const root=window.Shopify?.routes?.root || '/';
      let response;
      try {
        response=await fetch(root+'cart/add.js',{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:quote.variantId,quantity:1,properties:designed()}]})
        });
      } catch(error) {
        throw new Error('We could not confirm your cart. Please check your cart before trying again.');
      }
      const result=await response.json().catch(()=>null);
      if(!response.ok) throw new Error(result?.description || result?.message || 'This Mirror could not be added. Please try again.');
      window.location.assign(root+'cart');
    })().catch(error=>{cartRequest=null;throw error;});
    return cartRequest;
  };
  window.VIULET_PRODUCT_PAGE.startingPrice=product.price_min/100;
  window.VIULET_PRODUCT_PAGE.currency=currency;
  window.VIULET_PRODUCT_PAGE.collectionUrl='/collections/mirrors';
  window.VIULET_PRODUCT_PAGE.oracleUrl='/pages/oracle';
})();
